'use client';

import AddToShoppingCartButton from "@/components/ShoppingCart/AddToShoppingCartButton";
import { Note } from "@/lib/queries";
import sanityImage from "@/lib/sanityImage";
import { categories } from "@/schemas/data";
import clsx from "clsx";
import Image from "next/image";
import Link from "next/link";

const NoteCard = ({ note, isLoggedIn, userID }: { note: Note, isLoggedIn: boolean, userID?: string }) => {
    return (<div className="not-prose my-2 md:grid md:grid-cols-4 gap-5 border rounded-lg bg-neutral-100 dark:bg-neutral-900">
        <div className="min-h-[200px] md:col-span-2 w-full md:h-full relative rounded-lg md:overflow-hidden">
            <Image
                src={sanityImage(note.image).auto("format").width(500).height(500).fit('fill').url()}
                alt={note.image.alt ?? ""}
                fill
                className="object-cover" />
        </div>
        <div className="not-prose md:col-span-2 p-5 flex flex-col *:w-full justify-center *:my-2">
            <h3 className="text-xl font-bold">{note.name}</h3>
            <p className="">單元：{[...categories].find((c) => c.value === note.category)?.title}</p>
            <p className="text-gray-500 dark:text-gray-400 text-sm">{note.description}</p>
            <div className="flex items-center">
                <span className={clsx("text-xs rounded-lg p-2", {
                    "bg-green-500 text-white": note.status === "available",
                    "bg-yellow-500 text-white": note.status === "pre-order",
                    "bg-red-500 text-white": note.status === "discontinued",
                    "bg-gray-500 text-white": note.status === "hidden",
                })}>
                    {note.status === "available" ? "現正發售" : note.status === "pre-order" ? "可供預訂" : note.status === "discontinued" ? "已經停售" : "已被隱藏"}
                </span>
            </div>
            <hr className="my-2" />
            <div className="flex items-center gap-2">
                <p className="text-sm">HK $</p>
                <p className="text-2xl font-bold">{note.price}</p>
            </div>
            <div className="flex items-center gap-2">
                {
                    note.sellingMethod === "internal" && isLoggedIn && <AddToShoppingCartButton type="note" id={note.slug.current ?? ""} userID={userID} className="w-fit inline-block px-2 py-1 rounded-md bg-rose-500 text-white border no-underline text-center hover:scale-105 transition-normal text-sm cursor-pointer">加入購物車</AddToShoppingCartButton>
                }
                {
                    note.sellingMethod === "internal" && !isLoggedIn && <Link href="/login?r=notes" className="w-fit inline-block px-2 py-1 rounded-md bg-rose-500 text-white border no-underline text-center hover:scale-105 transition-normal text-sm cursor-pointer">請先登入</Link>
                }
                {
                    note.sellingMethod === "external" && <Link href={note.externalFormLink ?? "#"} className="w-fit inline-block px-2 py-1 rounded-md bg-rose-500 text-white border no-underline text-center hover:scale-105 transition-normal text-sm cursor-pointer" target="_blank">前往購買</Link>
                }

                <Link href={`/notes/${note.slug.current ?? "#"}`} className="w-fit inline-block px-2 py-1 rounded-md border-rose-500 border no-underline text-center hover:scale-105 transition-normal text-sm">了解更多</Link>
            </div>
        </div>
    </div>)
}

export default NoteCard; 